import Type from './Type';
export function isILinkDirect(discourse) {
    return discourse.type === Type.Direct;
}
export {
    isILinkDirect as isIDirect
};
export default isILinkDirect;    //# sourceMappingURL=isIDirect.js.map
